import { savingsOpportunitiesDataSelector } from "./savingsOpportunitiesDataSelector";
import { RootState } from "../../store";

export const savingsOpportunitiesDataLengthSelector = (
  state: RootState,
  resourceId?: string,
) => {
  return savingsOpportunitiesDataSelector(state, resourceId)?.length ?? 0;
};
